import { graphql } from 'relay-runtime';

export const getCurriculumLessonsByFilter = graphql`
  query ExitSlipCurriculumLessonsQuery($filter: CurriculumLessonsFilterInput) {
    curriculumLessons(filter: $filter) {
      id
      hasExitSlip
      isActive
      name
      number
      target {
        id
        name
      }
      curriculumLessonTargetSkills {
        targetSkill {
          skill {
            code
          }
        }
      }
      classExitSlips {
        dueOn
        canceledOn
        id
        class {
          id
          name
        }
      }
    }
  }
`;

export const getClassExitSlipsByFilter = graphql`
  query ExitSlipClassExitSlipsQuery(
    $filter: ClassExitSlipsFilterInput
    $learnosityExitSlipSessionsFilter: LearnosityExitSlipSessionsFilterInput
  ) {
    classExitSlips(filter: $filter) {
      id
      canceledOn
      curriculumLesson {
        id
        number
        name
        skills {
          code
          id
          name
        }
        targetGroup {
          name
        }
      }
      learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: $learnosityExitSlipSessionsFilter) {
        activityId
        id
        isComplete
        maxScore
        publicUserId
        score
        sessionId
        items {
          id
          score
          itemReference
          maxScore
          attempted
          questionNumber
        }
        user {
          firstName
          lastName
          fullName
          publicUserId
        }
      }
      class {
        id
        name
        userClasses {
          createdOn
          user {
            id
            lastName
            fullName
            publicUserId
            roles {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getAllClassExitSlip = graphql`
  query ExitSlipAllClassExitSlipQuery($filter: ClassExitSlipsFilterInput) {
    classExitSlips(filter: $filter) {
      id
      dueOn
      canceledOn
      class {
        id
      }
      curriculumLesson {
        id
        number
        name
      }
      learnosityExitSlipSessions {
        sessionCompletedOn
      }
    }
  }
`;

export const getExitSlipLessonRoadmaps = graphql`
  query ExitSlipLessonRoadmapsQuery {
    curriculumLessons(filter: { hasExitSlip: true, isActive: ACTIVE }) {
      id
      targetGroup {
        id
      }
    }
  }
`;

export const getAssignedExitSlipLessons = graphql`
  query ExitSlipAssignedLessonsQuery($filter: ClassExitSlipsFilterInput, $skip: Boolean = false) {
    classExitSlips(filter: $filter) @skip(if: $skip) {
      curriculumLesson {
        id
        target {
          id
        }
      }
    }
  }
`;

export const getClassExitSlipDueOnByClasses = graphql`
  query ExitSlipClassExitSlipDueOnByClassesQuery($filter: ClassExitSlipsFilterInput) {
    classExitSlips(filter: $filter) {
      dueOn
      canceledOn
      curriculumLesson {
        id
        number
      }
    }
  }
`;

export const getLastLoginTimeStampForTeacherOrAdmin = graphql`
  query ExitSlipLastLoginTimeStampForTeacherOrAdminQuery($filter: AllUserActionFilterInput!) {
    allUserActions(filter: $filter, order: { timeStamp: DESC }, first: 1) {
      nodes {
        timeStamp
      }
    }
  }
`;

export const addClassExitSlip = graphql`
  mutation ExitSlipUpsertClassExitSlipMutation($input: UpsertClassExitSlipInput!) {
    upsertClassExitSlip(input: $input) {
      classExitSlipNode {
        id
        curriculumLesson {
          id
          number
          name
        }
        dueOn
      }
      errors {
        ... on UnauthorizedAccessError {
          message
        }
        ... on InvalidIdsError {
          message
        }
      }
    }
  }
`;

export const cancelClassExitSlipById = graphql`
  mutation ExitSlipCancelClassExitSlipMutation($input: CancelClassExitSlipInput!) {
    cancelClassExitSlip(input: $input) {
      classExitSlipNode {
        id
        dueOn
        canceledOn
      }
      errors {
        ... on UnauthorizedAccessError {
          message
        }
        ... on InvalidIdsError {
          message
        }
      }
    }
  }
`;

export const deleteClassExitSlipByFilter = graphql`
  mutation ExitSlipDeleteClassExitSlipMutation($input: DeleteClassExitSlipInput!) {
    deleteClassExitSlip(input: $input) {
      classExitSlipNode {
        id
        dueOn
      }
      errors {
        ... on UnauthorizedAccessError {
          message
        }
        ... on InvalidIdsError {
          message
        }
      }
    }
  }
`;

// Every `id` below is aliased, and has to stay that way — do not "tidy" them back.
//
// These are flat report types (BaseSkillInfo, CurriculumLessonInfo, ...) rather than nodes: their
// ids are plain `Int!`, unique only within their own table. Relay takes any field literally named
// `id` as the record's global key in its normalized store, and requires it to be a string. Asking
// for `id` unaliased therefore breaks twice over: the normalizer throws on the number outright
// ("RelayResponseNormalizer: Expected id on field `x` to be a string"), and even as a string, two
// different types sharing a number — a classExitSlip 1 and its session 1, which this resolver
// really does return — would collapse onto the same record. Under an alias the payload has no `id`
// key, so Relay keys these by their position in the response instead, which is what they are: rows
// of a report, not identities.
export const exitSlipsBySkills = graphql`
  query ExitSlipExitSlipsBySkillsQuery($studentId: ID!, $targetGroupId: ID!) {
    studentExitSlipReport(studentId: $studentId, targetGroupId: $targetGroupId) {
      curriculumLessons {
        hasExitSlip
        curriculumLessonId: id
        name
        number
        classExitSlips {
          learnosityExitSlipSession {
            sessionId: id
            maxScore
            score
          }
          classExitSlipId: id
        }
      }
      skillInfo {
        code
        skillId: id
        name
      }
    }
  }
`;
